module.exports = __webpack_public_path__ + "img/hkp2000.1b9c61e7.svg";